// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__IJ-pk","copyright":"styles_copyright__FPc8z"};